import { Link } from 'react-router-dom';

function WhyUsPage() {
  return (
    <div>
      <section className="mx-auto grid max-w-7xl items-center gap-12 px-4 pb-20 pt-12 md:grid-cols-12 md:px-8">
        <div className="md:col-span-7">
          <span className="mb-5 inline-block rounded-full bg-surfaceContainer px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-primary">
            Excelencia en ingeniería
          </span>
          <h1 className="text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
            Elevamos el software a una forma de arte matemática.
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-onSurfaceVariant">
            Integridad técnica, velocidad de ejecución y pensamiento de producto para construir
            plataformas sólidas y competitivas.
          </p>
          <Link to="/contacto" className="mt-9 inline-block rounded-md bg-primary px-7 py-3 font-bold text-white">
            Explorar metodología
          </Link>
        </div>
        <div className="relative md:col-span-5">
          <div className="aspect-square overflow-hidden rounded-2xl bg-surfaceContainerLow">
            <img
              src="/assets/images/why-us/Profesionales_analizando.png"
              alt="Profesionales analizando estrategia"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="bg-surfaceContainerLow py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-onSurfaceVariant">
            Aliados estratégicos
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-10 text-2xl font-extrabold text-onSurface/60">
            <span>FORTUNE</span>
            <span>STELLAR</span>
            <span>NEXUS</span>
            <span>EQUINOX</span>
            <span>VORTEX</span>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-24 md:px-8">
        <h2 className="text-3xl font-extrabold md:text-4xl">Diferenciadores clave</h2>
        <div className="mt-10 grid gap-6 md:grid-cols-12">
          <article className="rounded-2xl border border-outlineVariant/30 bg-white p-8 md:col-span-8">
            <span className="material-symbols-outlined text-primary">terminal</span>
            <h3 className="mt-4 text-2xl font-bold">Diseño centrado en lógica</h3>
            <p className="mt-3 text-onSurfaceVariant">
              Toda decisión técnica responde a escalabilidad, mantenibilidad y retorno de inversión,
              no solo a estética.
            </p>
          </article>
          <article className="rounded-2xl bg-gradient-to-r from-primaryContainer to-primary p-8 text-white md:col-span-4">
            <span className="material-symbols-outlined">bolt</span>
            <h3 className="mt-4 text-2xl font-bold">Velocidad de ejecución</h3>
            <p className="mt-3 text-white/85">
              Ciclos ágiles y equipos senior para reducir time-to-market sin comprometer calidad.
            </p>
          </article>
          <article className="rounded-2xl bg-surfaceContainer p-8 md:col-span-5">
            <span className="material-symbols-outlined text-primary">verified_user</span>
            <h3 className="mt-4 text-2xl font-bold">Seguridad por diseño</h3>
            <p className="mt-3 text-onSurfaceVariant">
              Ciberseguridad integrada en arquitectura y desarrollo desde el primer sprint.
            </p>
            <img
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuABNaoKmTweO-JyhjRCaQW24VwRrZUPADKOK4puHJO77yTgsp-rr64SeLCvPiUBP-ymhz3l1y6UfyqC35dy71rFiKvNQ-I0tFXSUlHXluILHvnaIxBl1m5zJkuwmvr99fB9x9xuLpqbjMpW08WvGF55WbV5eptOddQY5arVVp5yrX_cjqdjyOv39dQmO3ODt1mPEgOkYTDdjWo9TJKvnkvqgzSdir2XFVSyqMLwjNhUHsTnv2Z8tLnFdxY6BNuU3b7wSmpMEvCRgz4b"
              alt="Seguridad digital"
              className="mt-6 h-40 w-full rounded-xl object-cover"
            />
          </article>
          <article className="rounded-2xl bg-surfaceContainerLow p-8 md:col-span-7">
            <h3 className="text-4xl font-extrabold text-onSurface/15">ARCHITECTURE</h3>
            <div className="mt-8 grid gap-6 sm:grid-cols-2">
              <div>
                <p className="font-bold">Mentalidad de producto</p>
                <p className="text-sm text-onSurfaceVariant">Tecnología conectada a objetivos de negocio.</p>
              </div>
              <div>
                <p className="font-bold">Ingeniería ética</p>
                <p className="text-sm text-onSurfaceVariant">Transparencia total en decisiones y costos.</p>
              </div>
              <div>
                <p className="font-bold">Cloud Native</p>
                <p className="text-sm text-onSurfaceVariant">Arquitectura pensada para resiliencia.</p>
              </div>
              <div>
                <p className="font-bold">IA aplicada</p>
                <p className="text-sm text-onSurfaceVariant">Automatización y eficiencia operacional.</p>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="bg-surfaceContainerLow py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <h2 className="text-3xl font-extrabold">Lo que dicen nuestros partners</h2>
          <div className="mt-10 grid gap-6 md:grid-cols-2">
            <article className="rounded-xl bg-white p-8 shadow-sm">
              <p className="text-lg italic text-onSurface">
                "Krystal transformó nuestra infraestructura legacy en una plataforma escalable en
                tiempo récord."
              </p>
              <p className="mt-6 text-sm font-semibold text-onSurfaceVariant">Elena Rodriguez, CTO</p>
            </article>
            <article className="rounded-xl bg-white p-8 shadow-sm">
              <p className="text-lg italic text-onSurface">
                "Reducimos costos de mantenimiento y mejoramos la eficiencia operativa en semanas."
              </p>
              <p className="mt-6 text-sm font-semibold text-onSurfaceVariant">Marco Valenti, COO</p>
            </article>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-24 md:px-8">
        <div className="rounded-2xl bg-inverseSurface p-12 text-center text-white">
          <h2 className="text-3xl font-extrabold text-primary md:text-5xl">¿Listo para construir el futuro de su empresa?</h2>
          <p className="mx-auto mt-4 max-w-2xl text-slate-700">
            Diseñamos una estrategia tecnológica para llevar tu producto al siguiente nivel.
          </p>
          <Link to="/contacto" className="mt-8 inline-block rounded-md bg-primary px-7 py-3 font-bold text-white">
            Agendar consultoría técnica
          </Link>
        </div>
      </section>
    </div>
  );
}

export default WhyUsPage;
